import React from 'react';

import FooterImg from '../../../../images/farm-illustration.svg';

const Footer = () => {
  return (
    <div className="">
      <img src={FooterImg} alt="Farm Illustration" />
    </div>
  );
};

export default Footer;
